// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2lNbU","title":"AfterFrontImage_title__YIKC_"};